import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import Selects from "./Selects";

function Navbar() {

    const {openMenu, lang} = useContext(GlobalContext)

    console.log(lang);

    useEffect(() =>{
        console.log("nav:",lang);
    }, [lang])

    return(
        <div className="navbar">
            {lang === ""
            ?
                null
            :

                <div className="navbar__bar">
                    <div className="navbar__menu">
                        <div className="navbar__title" onClick={() => openMenu()}>MENU</div>
                        <div className="navbar__select">
                            <Selects />
                        </div>
                    </div>

                    <div className="navbar__home">
                        <Link to="/"><h5>HOME</h5></Link>
                    </div>
                </div>

            }
        </div>
    )
}

export default Navbar